"use client";

import cn from "@utils/cn";
import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import Image from "next/image";
import React, { Fragment, useContext } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Icon from "@/components/ui/Icon/Icon";
import { ModalsContext } from "@/context/ModalsContext";

import { EditorialModuleText as EditorialModuleTextType } from "./type";

export interface EditorialModuleTextProps {
  entry: EditorialModuleTextType;
  kpiHiddenOnMobile?: boolean;
}

export default function EditorialModuleText({ entry, kpiHiddenOnMobile }: EditorialModuleTextProps) {
  const { setContactUsModalOpen } = useContext(ModalsContext);
  const locale = useLocale();

  return (
    <div className="h-full flex flex-col px-m md:pt-xxl md:p-0 md:justify-center md:items-end">
      <div className="md:w-[70%] md:mr-[40px] flex flex-col gap-3xl md:gap-xl rtl:md:mr-0 rtl:md:ml-[40px]">
        <div className="flex flex-col" style={{ marginTop: "16px" }}>
          {entry.title && <p className="font-normal uppercase font-primary text-l">{entry.title}</p>}
          {entry.body && (
            <p className="font-secondary font-secondary-light text-m" style={{ marginTop: "16px" }}>
              {entry.body}
            </p>
          )}
        </div>
        {entry.kpIs && (
          <div
            className={`${kpiHiddenOnMobile ? "hidden md:flex " : "flex flex-col "} md:${entry?.isFootprint ? "flex-col" : "flex-row"} md:justify-between md:gap-xl px-m md:px-0 kpiCustom`}
          >
            {entry.kpIs.map((item, index) => (
              <Fragment key={index}>
                <div className={`flex  items-left md:flex-row md:items-center md:justify-left md:align-baseline`} key={index}>
                  {item?.icon && <Image src={`/icons/${item.icon}`} width="40" height="40" alt="Play Video" />}
                  <p className="text-center font-primary text-xl text-black-0 md:text-left md:pt-xxs" style={{ paddingLeft: "10px" }}>
                    {item.title?.split("+").map((part: any, i: any, arr: any) => (
                      <Fragment key={i}>
                        {part}
                        {i < arr.length - 1 && <span style={{ color: "#CCB073" }}>+</span>}
                      </Fragment>
                    ))}
                  </p>
                  <p
                    className="text-center  font-primary text-m font-secondary-light text-black-0 md:text-left md:pt-xs"
                    style={{ paddingLeft: "10px" }}
                  >
                    {item.subtitle?.split("+").map((part: any, i: any, arr: any) => (
                      <Fragment key={i}>
                        {part}
                        {i < arr.length - 1 && <span style={{ color: "gold" }}>+</span>}
                      </Fragment>
                    ))}
                  </p>
                </div>
              </Fragment>
            ))}
          </div>
        )}
        {entry.cta && (
          <div className="flex justify-center md:justify-normal md:mt-xl md: mb-l">
            <Button
              href={entry.cta.link.linkType === "external" && entry?.cta?.link?.url === "contact-us" ? undefined : getLink(entry.cta, locale)}
              type="button"
              size={ButtonSize.MEDIUM}
              variant={ButtonVariant.PRIMARY}
              theme={ButtonTheme.BLACK}
              onClick={() => {
                if (entry?.cta?.link?.url === "contact-us") {
                  setContactUsModalOpen(true);
                }
              }}
              onTouchStart={() => {
                if (entry?.cta?.link?.url === "contact-us") {
                  setContactUsModalOpen(true);
                }
              }}
            >
              {entry.cta.label}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
